
/**
 * 時間格式轉換
 * @param time  被轉換的時間
 * @param timeFormat input資料的格式 (ex. x : ms, YYYY.MM.DD)
 * @param format 格式 (預設YYYY/MM/DD)
 * @returns 
 */
import * as moment from 'moment';
export const dateTimeHandle = (time, timeFormat = '', format = 'YYYY/MM/DD') => {
    return timeFormat === '' ? moment(time).format(format) : moment(time, timeFormat).format(format)
}
